import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const MaskScroll = () => {
  const wrap = document.querySelector('.js-mask-wrap');
  if (!wrap) return;

  const img = wrap.querySelector('.js-mask-img');
  if (!img) return;

  const proxy = { r: 0 };

  const setWrapHeight = () => {
    wrap.style.height = `${window.innerHeight * 2}px`;
  };
  setWrapHeight();

  gsap.to(proxy, {
    r: 150,
    ease: 'none',
    scrollTrigger: {
      trigger: wrap,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 1.2,
      invalidateOnRefresh: true,
      onRefresh: (self) => {
        // リロード・リサイズ時に現在のprogressに合わせて即座に反映
        proxy.r = 150 * self.progress;
        img.style.setProperty('--r', `${proxy.r}%`);
      },
    },
    onUpdate: () => {
      img.style.setProperty('--r', `${proxy.r}%`);
    },
  });
};

const MaskScrollResize = () => {
  const wrap = document.querySelector('.js-mask-wrap');
  if (!wrap) return;

  wrap.style.height = `${window.innerHeight * 2}px`;
  ScrollTrigger.refresh();
};

export default MaskScroll;
export { MaskScrollResize };
